import React from 'react';
import { motion } from 'framer-motion';
const paragraphs = ['There was a moment when I felt lost. Without direction, without a clear purpose. Instead of looking for answers outside, something drew me inward.', 'It became a long process, more than a year, and in many ways it is still ongoing. Because when you truly begin to look at yourself, you realize there is no ending, only new layers.', 'In that journey, I encountered my shadows: the fears I had avoided, unresolved experiences, inherited ways of seeing the world that were not entirely mine. Things that came before me, which I had quietly made my own without realizing it.', 'I have always been analytical, deeply in my head. Learning to connect with what I feel was like learning another language.', 'In that process, photography took on a different meaning. For more than ten years it had been part of my life, but this is where everything aligned.', 'Someone once told me that an artist creates their work when they have something real to say. For the first time, I felt I did. I had something to say.', 'That is how this series was born. Ten images that mark moments along an inner journey, where light and shadow coexist, as they do within us.', 'This work is for those who have been through something similar, and for those who have not yet dared to look within. Because in the end, there is light. I was able to align body, mind, and soul, and bring this exhibition to life after years of hesitation, of believing there was nothing worth showing.', 'There was. There always was.'];
export function ArtistStatement() {
  return <section className="bg-charcoal py-28 md:py-40 px-6 md:px-12" data-id="element-21">
      <div className="max-w-3xl mx-auto" data-id="element-22">
        <motion.p initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="md:text-xs font-sans tracking-[0.3em] uppercase text-gray-500 text-center mb-16 text-[16px] font-[500]" data-id="element-23">
          BETWEEN LIGHTS AND SHADOWS
        </motion.p>

        <div className="space-y-8 md:space-y-10" data-id="element-24">
          {paragraphs.map((text, i) => {
          const isLast = i === paragraphs.length - 1;
          return <motion.p key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.7,
            delay: i * 0.05
          }} className={`text-center leading-relaxed ${isLast ? 'font-serif text-2xl md:text-3xl text-white mt-16' : 'font-serif text-lg md:text-xl text-gray-300'}`} data-id="element-25">
                {isLast ? <em data-id="element-26">{text}</em> : text}
              </motion.p>;
        })}
        </div>
      </div>
    </section>;
}